import { Component } from '@angular/core';

@Component({
  selector: 'app-how-it-works',
  template: `
    <!-- ========== PAGE HERO ========== -->
    <section class="ds-page-hero">
      <div class="ds-orb ds-orb--soft ds-page-hero__orb-1"></div>
      <div class="ds-orb ds-orb--cobalt ds-page-hero__orb-2"></div>
      <div class="container ds-page-hero__inner">
        <span class="ds-pill">Nasıl Çalışır</span>
        <h1>Keyo AI Nasıl Çalışır?</h1>
        <p class="ds-lead">Keyo AI, e-ticaret sitenize entegre olarak müşterilerinize mükemmel deneyim sunar.</p>
      </div>
    </section>

    <section class="ds-section ds-hiw">
      <div class="ds-orb ds-orb--cobalt ds-hiw__orb-1"></div>
      <div class="ds-orb ds-orb--soft   ds-hiw__orb-2"></div>
      <div class="ds-orb ds-orb--midnight ds-hiw__orb-3"></div>
      <div class="container">
        <!-- ========== SERVICES GRID ========== -->
        <div class="ds-hiw__grid">
          <div class="ds-hiw__service" (mousemove)="onServiceMove($event)" (mouseleave)="onServiceLeave($event)">
            <div class="ds-hiw__service-icon">
              <img src="assets/images/voice-search.svg" alt="Voice Agent">
            </div>
            <h4>Voice Agent</h4>
            <p>Telefon konuşması doğallığında sesli destek; ürün sorgulama, sipariş ve iade, hepsi sesle.</p>
          </div>
          <div class="ds-hiw__service" (mousemove)="onServiceMove($event)" (mouseleave)="onServiceLeave($event)">
            <div class="ds-hiw__service-icon">
              <img src="assets/images/chat-support.svg" alt="Yazılı Sohbet">
            </div>
            <h4>Yazılı Sohbet</h4>
            <p>Anlık mesajlaşma. Ürün kartları, detay butonları ve doğal Türkçe yanıtlar.</p>
          </div>
          <div class="ds-hiw__service" (mousemove)="onServiceMove($event)" (mouseleave)="onServiceLeave($event)">
            <div class="ds-hiw__service-icon">
              <img src="assets/images/product-recommendation.svg" alt="Ürün Karşılaştırma">
            </div>
            <h4>Ürün Karşılaştırma</h4>
            <p>Fiyat karşılaştırması ve detaylı açıklamalar. Carousel kartlarda doğrudan ürün sayfasına yönlendirme.</p>
          </div>
          <div class="ds-hiw__service" (mousemove)="onServiceMove($event)" (mouseleave)="onServiceLeave($event)">
            <div class="ds-hiw__service-icon">
              <img src="assets/images/order-tracking.svg" alt="Sipariş ve Kargo Takibi">
            </div>
            <h4>Sipariş & Kargo Takibi</h4>
            <p>Anlık sipariş durumu, teslimat tarihi ve kargo bilgisi sorgulama.</p>
          </div>
          <div class="ds-hiw__service" (mousemove)="onServiceMove($event)" (mouseleave)="onServiceLeave($event)">
            <div class="ds-hiw__service-icon">
              <img src="assets/images/returns.svg" alt="Otomatik Destek Talebi">
            </div>
            <h4>Otomatik Destek Talebi</h4>
            <p>"İade", "iptal", "şikayet" tetikleyicilerini algılar; aciliyet seviyesiyle ekibinize ticket oluşturur.</p>
          </div>
          <div class="ds-hiw__service" (mousemove)="onServiceMove($event)" (mouseleave)="onServiceLeave($event)">
            <div class="ds-hiw__service-icon">
              <img src="assets/images/multilingual.svg" alt="Çok Kanallı Erişim">
            </div>
            <h4>Çok Kanallı Erişim</h4>
            <p>Web sitesi, WhatsApp, Instagram ve Facebook.. Müşterileriniz hangi kanaldan ulaşırsa ulaşsın aynı yapay zeka.</p>
          </div>
        </div>

        <!-- ========== ALTERNATING SPLITS ========== -->
        <div class="ds-hiw__split">
          <div class="row align-items-center g-5">
            <div class="col-lg-6">
              <span class="ds-pill">Voice + Text</span>
              <h2>Tam Entegre Voice & Text Agent Deneyimi</h2>
              <p class="ds-lead mb-4">Keyo AI, e-ticaret sitenize kolayca entegre olur ve müşterilerinize hem sesli hem de yazılı destek sunar:</p>
              <ul class="ds-hiw__list">
                <li>Sesli arama ve ürün bulma</li>
                <li>Anlık sipariş durumu kontrolü</li>
                <li>Kargo ve iade bilgisi sorgulama</li>
                <li>Ürün önerileri ve alternatif ürünler</li>
                <li>Sepete ekleme ve sipariş verme</li>
              </ul>
              <a routerLink="/contact" fragment="contact-form" class="btn btn-primary mt-4">Demo Talep Et</a>
            </div>
            <div class="col-lg-6">
              <div class="ds-panel">
                <div class="ds-frame">
                  <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
                  <div class="ds-frame__body"><img src="assets/images/voice-text-agent.svg" alt="Voice ve Text Agent"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ds-hiw__split">
          <div class="row align-items-center g-5 flex-row-reverse">
            <div class="col-lg-6">
              <span class="ds-pill">Altyapı</span>
              <h2>Teknik Altyapı</h2>
              <p class="ds-lead mb-4">En son teknolojiler kullanılarak geliştirilen Keyo AI, e-ticaret sitenize hızlı ve sorunsuz entegre olur:</p>
              <ul class="ds-hiw__list">
                <li>Basit GTM entegrasyonu</li>
                <li>Tüm e-ticaret platformları ile uyumlu</li>
                <li>Gelişmiş NLP altyapısı</li>
                <li>Düşük gecikme süresi, yüksek performans</li>
                <li>Özelleştirilebilir arayüz</li>
              </ul>
            </div>
            <div class="col-lg-6">
              <div class="ds-panel">
                <div class="ds-frame">
                  <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
                  <div class="ds-frame__body"><img src="assets/images/technical.svg" alt="Teknik Altyapı"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ds-hiw__split">
          <div class="row align-items-center g-5">
            <div class="col-lg-6">
              <span class="ds-pill">Güvenlik</span>
              <h2>KVKK ve GDPR Uyumlu Güvenli Yapay Zeka Çözümü</h2>
              <p class="ds-lead mb-4">Keyo AI, tüm yasal düzenlemelere uygun olarak geliştirilmiştir:</p>
              <ul class="ds-hiw__list">
                <li>KVKK ve GDPR uyumlu veri işleme</li>
                <li>Uçtan uca şifreleme</li>
                <li>Güvenli veri saklama politikaları</li>
                <li>Veri minimizasyonu prensibi</li>
                <li>Düzenli güvenlik denetimleri</li>
              </ul>
            </div>
            <div class="col-lg-6">
              <div class="ds-panel">
                <div class="ds-frame">
                  <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
                  <div class="ds-frame__body"><img src="assets/images/security.svg" alt="Veri Güvenliği"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ds-hiw__split">
          <div class="row align-items-center g-5 flex-row-reverse">
            <div class="col-lg-6">
              <span class="ds-pill">Analitik</span>
              <h2>Analitik ve Raporlama</h2>
              <p class="ds-lead mb-4">Müşteri etkileşimlerini detaylı olarak analiz ederek işletmenize değer katın:</p>
              <ul class="ds-hiw__list">
                <li>Detaylı veriler</li>
                <li>Konuşma analizleri</li>
                <li>Müşteri memnuniyet ölçümleri</li>
                <li>Toplam ve ortalama kullanım</li>
                <li>Özelleştirilebilir dashboard</li>
              </ul>
            </div>
            <div class="col-lg-6">
              <div class="ds-panel">
                <div class="ds-frame">
                  <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
                  <div class="ds-frame__body"><img src="assets/images/analytics.svg" alt="Analitik ve Raporlama"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ds-hiw__split">
          <div class="row align-items-center g-5">
            <div class="col-lg-6">
              <span class="ds-pill">7/24 Destek</span>
              <h2>7/24 Kesintisiz Destek</h2>
              <p class="ds-lead mb-4">Müşterilerinize her an yanıt veren akıllı asistan çözümü:</p>
              <ul class="ds-hiw__list">
                <li>Anlık müşteri desteği</li>
                <li>Otomatik problem çözümü</li>
                <li>İnsan destekçilere sorunsuz geçiş</li>
                <li>Çoklu dil desteği</li>
                <li>Kişiselleştirilmiş yanıtlar</li>
              </ul>
            </div>
            <div class="col-lg-6">
              <div class="ds-panel">
                <div class="ds-frame">
                  <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
                  <div class="ds-frame__body"><img src="assets/images/support.svg" alt="7/24 Destek"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ds-hiw__split">
          <div class="row align-items-center g-5 flex-row-reverse">
            <div class="col-lg-6">
              <span class="ds-pill">Entegrasyon</span>
              <h2>Kolay Entegrasyon ve Kurulum</h2>
              <p class="ds-lead mb-4">Hızlı ve sorunsuz entegrasyon süreci ile vakit kaybetmeyin:</p>
              <ul class="ds-hiw__list">
                <li>Hazır entegrasyon paketleri</li>
                <li>Teknik destek ve danışmanlık</li>
                <li>Özelleştirilebilir widget</li>
                <li>Hızlı kurulum süreci</li>
              </ul>
            </div>
            <div class="col-lg-6">
              <div class="ds-panel">
                <div class="ds-frame">
                  <div class="ds-frame__chrome"><span></span><span></span><span></span></div>
                  <div class="ds-frame__body"><img src="assets/images/integration.svg" alt="Kolay Entegrasyon"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ========== FINAL CTA ========== -->
    <section class="ds-final-cta">
      <div class="container">
        <div class="ds-final-cta__panel">
          <div class="ds-orb ds-orb--soft ds-final-cta__orb"></div>
          <div class="ds-final-cta__content">
            <h2>Keyo AI'yı Sitenize Entegre Edin</h2>
            <p class="ds-lead">Demo talep edin, ekibimiz size en uygun entegrasyonu kursun.</p>
            <a routerLink="/contact" fragment="contact-form" class="btn btn-light btn-lg mt-3">Demo Talep Et</a>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .ds-hiw__head {
      margin-bottom: 64px;
    }
    .ds-hiw__head .ds-lead {
      max-width: 60ch;
      margin: 0 auto;
    }

    /* ===== Section background + orbs (so glass refracts color) ===== */
    .ds-hiw {
      position: relative;
      background:
        linear-gradient(180deg, #FFFFFF 0%, #EAF0FB 35%, #F5F7FB 70%, #FFFFFF 100%);
      overflow: hidden;
    }
    .ds-hiw .container { position: relative; z-index: 1; }

    .ds-hiw__orb-1 { width: 520px; height: 520px; top: 4%; left: -160px; opacity: 0.55; }
    .ds-hiw__orb-2 { width: 600px; height: 600px; top: 18%; right: -200px; opacity: 0.65; }
    .ds-hiw__orb-3 { width: 480px; height: 480px; top: 4%; left: 42%; opacity: 0.30; }

    /* ===== Grid: 3 × 2 (perspective for 3D tilt) ===== */
    .ds-hiw__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      margin-bottom: 96px;
      perspective: 1200px;
    }
    @media (max-width: 992px) {
      .ds-hiw__grid { grid-template-columns: repeat(2, 1fr); }
    }
    @media (max-width: 576px) {
      .ds-hiw__grid { grid-template-columns: 1fr; }
    }
    @media (max-width: 768px) {
      .ds-hiw__grid { margin-bottom: 64px; }
    }

    /* ===== Glass service card ===== */
    .ds-hiw__service {
      position: relative;
      padding: 28px;
      border-radius: var(--ds-radius-panel);
      background: rgba(255, 255, 255, 0.45);
      -webkit-backdrop-filter: blur(20px) saturate(180%);
      backdrop-filter: blur(20px) saturate(180%);
      border: 1px solid rgba(255, 255, 255, 0.55);
      box-shadow:
        0 18px 40px -18px rgba(0, 71, 171, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.65),
        inset 0 0 0 1px rgba(255, 255, 255, 0.20);
      overflow: hidden;
      transform-style: preserve-3d;
      transform: rotateX(var(--rx, 0deg)) rotateY(var(--ry, 0deg)) !important;
      transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1),
                  box-shadow 220ms ease;
      will-change: transform;
    }
    .ds-hiw__service:hover {
      box-shadow:
        0 30px 60px -20px rgba(0, 71, 171, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.75),
        inset 0 0 0 1px rgba(255, 255, 255, 0.30);
    }

    /* Cursor-tracking glare */
    .ds-hiw__service::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background: radial-gradient(
        520px circle at var(--mx, 50%) var(--my, 50%),
        rgba(255, 255, 255, 0.55) 0%,
        rgba(255, 255, 255, 0.10) 18%,
        transparent 42%
      );
      opacity: 0;
      transition: opacity 320ms ease;
      pointer-events: none;
      z-index: 0;
    }
    .ds-hiw__service:hover::before { opacity: 1; }

    /* Bottom-edge sheen */
    .ds-hiw__service::after {
      content: "";
      position: absolute;
      left: 12%;
      right: 12%;
      bottom: -1px;
      height: 1px;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.7), transparent);
      pointer-events: none;
      z-index: 1;
    }

    /* Lift content above glare layer */
    .ds-hiw__service > * {
      position: relative;
      z-index: 2;
      transform: translateZ(0);
    }

    .ds-hiw__service-icon {
      width: 72px;
      height: 72px;
      border-radius: 12px;
      background:
        radial-gradient(circle at 30% 25%, rgba(255,255,255,0.85), transparent 60%),
        var(--ds-gradient-soft);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.25rem;
      padding: 12px;
      box-shadow:
        inset 0 1px 0 rgba(255,255,255,0.9),
        inset 0 0 0 1px rgba(0,40,94,0.10),
        0 6px 16px -8px rgba(148,184,240,0.55);
      transition: transform var(--ds-motion-base);
    }
    .ds-hiw__service:hover .ds-hiw__service-icon {
      transform: translateZ(20px) scale(1.04);
    }
    .ds-hiw__service-icon img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .ds-hiw__service h4 {
      font-size: 1.125rem;
      font-weight: 600;
      color: var(--ds-text-display);
      margin-bottom: 0.5rem;
    }
    .ds-hiw__service p {
      color: rgba(34, 53, 87, 0.78);
      margin: 0;
      font-size: 15px;
    }

    /* ===== Splits ===== */
    .ds-hiw__split {
      padding: 48px 0;
    }
    .ds-hiw__split:not(:last-child) {
      border-bottom: 1px solid var(--ds-border);
    }
    @media (max-width: 992px) {
      .ds-hiw__split { padding: 32px 0; }
    }

    .ds-hiw__list {
      list-style: none;
      padding: 0;
      margin: 0 0 1.5rem 0;
    }
    .ds-hiw__list li {
      position: relative;
      padding: 8px 0 8px 32px;
      color: var(--ds-text);
      font-size: 16px;
    }
    .ds-hiw__list li::before {
      content: '';
      position: absolute;
      left: 0;
      top: 14px;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: rgba(0,71,171,0.10);
    }
    .ds-hiw__list li::after {
      content: '\\f00c';
      font-family: 'Font Awesome 6 Free';
      font-weight: 900;
      position: absolute;
      left: 4px;
      top: 12px;
      color: var(--ds-cobalt);
      font-size: 10px;
    }
  `]
})
export class HowItWorksComponent {
  onServiceMove(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    const rect = card.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const ry = ((x - cx) / cx) * 7;
    const rx = ((y - cy) / cy) * -7;
    card.style.setProperty('--rx', `${rx}deg`);
    card.style.setProperty('--ry', `${ry}deg`);
    card.style.setProperty('--mx', `${x}px`);
    card.style.setProperty('--my', `${y}px`);
  }

  onServiceLeave(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    card.style.setProperty('--rx', '0deg');
    card.style.setProperty('--ry', '0deg');
  }
}
